export function initialLetters(str: string) {
    return str
        .split(' ')
        .slice(0, 4)
        .map(palavra => palavra.charAt(0))
        .join('');
}